import {
   Avatar,
   Card,
   CardContent,
   CardHeader,
   Divider,
   Grid,
   Typography,
   Button,
   colors
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import MUIDataTable from 'mui-datatables';
//GraphQL
import {useLazyQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';

import {Localizacion} from 'lib.front';
import {loadingModal, openMsg} from 'redux-app';

//Icons
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import {DatePicker} from '@material-ui/pickers';
import {endOfMonth, startOfMonth, format} from 'date-fns';

import SearchIcon from '@material-ui/icons/Search';

const today = new Date();

const queryServicioPostventa = gql`
   query($codCliente: String!, $fechaInicio: Date, $fechaFin: Date) {
      serviciosPostventa(codCliente: $codCliente, fechaInicio: $fechaInicio, fechaFin: $fechaFin) {
         codigo
         producto
         fechaVigencia
         nroLlamadas
         nroAct
         nroCap
         nroSop
      }
   }
`;

const useStyles = makeStyles(theme => ({
   tabla: {
      borderCollapse: 'collapse',
      border: 'none',
      background: theme.palette.background.paper,
      color: theme.palette.text.primary,
      '& .MuiTableCell-root': {
         fontWeight: 'normal',
         height: '11px',
         fontSize: '14px',
         padding: '10px'
      },
      '& .MuiTableCell-head': {
         border: '1px 1px solid #8dcbff',
         borderRadius: '10px',
         borderTop: 'none',
         textAlign: 'center',
         borderLeft: 'none',
         borderRight: 'none',
         fontWeight: 'normal'
      },
      '& .MuiToolbar-regular': {
         fontSize: '14px',
         minHeight: '10px',
         marginTop: '1rem',
         marginBottom: '1rem',
         paddingLeft: '10px',
         paddingRight: '0px'
      },
      '& .MuiTypography-h6': {
         fontWeight: 'bold',
         fontSize: '10px',
         margin: '0px'
      },
      '& .firstMuiTable': {
         borderCollapse: 'separate',
         border: '1px solid lightgray',
         borderRadius: '10px'
      },
      '& .Mui-selected': {
         backgroundColor: '#DFF0FF'
      }
   }
}));

const columns = [
   {
      name: 'producto',
      label: 'Producto',
      options: {
         filter: true,
         sort: true,
         display: true
      }
   },
   {
      name: 'fechaVigencia',
      label: 'Fecha de vigencia',
      options: {
         filter: true,
         sort: true,
         display: true,
         customBodyRender: (value, tableMeta) => {
            const fecha = new Date(value);
            const hoy = new Date();
            const esPasada = fecha < hoy;
            return (
               <span style={{color: esPasada ? 'red' : 'black'}}>
                  {format(fecha, 'dd/MM/yyyy')}
               </span>
            );
         }
      }
   },
   {
      name: 'nroLlamadas',
      label: 'Nro de llamadas',
      options: {
         filter: true,
         sort: true,
         display: true
      }
   },
   {
      name: 'nroAct',
      label: 'Nro de actualizaciones',
      options: {
         filter: true,
         sort: true,
         display: true
      }
   },
   {
      name: 'nroCap',
      label: 'Nro de capacitaciones',
      options: {
         filter: true,
         sort: true,
         display: true
      }
   },
   {
      name: 'nroSop',
      label: 'Nro de soportes',
      options: {
         filter: true,
         sort: true,
         display: true
      }
   }
];

const options = {
   filterType: 'dropdown',
   selectableRows: 'none',
   responsive: 'stacked',
   pagination: true,
   elevation: 0,
   rowsPerPage: 3,
   rowsPerPageOptions: [3, 10, 15, 100],
   rowHover: false,
   search: true,
   print: false,
   download: false,
   viewColumns: true,
   textLabels: Localizacion.muiDataTables.ES
};

const filtrosIniciales = {
   cliente: null,
   fechaInicio: startOfMonth(today),
   fechaFin: endOfMonth(today)
};

function formatGraphQLDate(date) {
   if (date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = ('0' + (d.getMonth() + 1)).slice(-2);
      const day = ('0' + d.getDate()).slice(-2);

      return `${year}-${month}-${day}`;
   }
   return date;
}
/*
Funciones y variables auxiliares globales
*/

function ServiciosPostventa({usuario, openWaitModal, openMsgModal}) {
   const classes = useStyles();
   const [dataTable, setDataTable] = useState([]);
   const [filtros, setFiltros] = useState(filtrosIniciales);
   const handleChangeFiltros = (elegido, propiedad) => {
      setFiltros(() => {
         return {...filtros, [propiedad]: elegido};
      });
   };
   let [
      getServicioPostventa,
      {data: dataPosventa, error: errorPostventa, loading: loadingPostventa}
   ] = useLazyQuery(queryServicioPostventa);
   useEffect(() => {
      openWaitModal(loadingPostventa);
   }, [loadingPostventa]);

   useEffect(() => {
      if (errorPostventa) {
         openMsgModal(errorPostventa.toString());
      }
   }, [errorPostventa]);

   useEffect(() => {
      if (dataPosventa) {
         setDataTable(dataPosventa.serviciosPostventa);
      }
   }, [dataPosventa]);

   useEffect(() => {
      if (usuario) {
         handleChangeFiltros(usuario.codigo, 'cliente');
         getServicioPostventa({
            variables: {
               codCliente: usuario.codigo,
               fechaInicio: formatGraphQLDate(filtros.fechaInicio),
               fechaFin: formatGraphQLDate(filtros.fechaFin)
            }
         });
      }
   }, [usuario]);

   const handleGetData = () => {
      getServicioPostventa({
         variables: {
            codCliente: filtros.cliente,
            fechaInicio: formatGraphQLDate(filtros.fechaInicio),
            fechaFin: formatGraphQLDate(filtros.fechaFin)
         }
      });
   };

   return (
      <Grid container spacing={3}>
         <Card>
            <CardHeader
               title={
                  <Typography component="p" color="textPrimary" variant="h5">
                     Servicios postventa
                  </Typography>
               }
               disableTypography={true}
               avatar={
                  <Avatar className={classes.avatar}>
                     <BusinessCenterIcon />
                  </Avatar>
               }
            />
            <Divider />
            <CardContent>
               <Grid container spacing={1}>
                  <Grid item xs={3}>
                     <DatePicker
                        name="fechaInicial"
                        label="Fecha Inicial"
                        value={filtros.fechaInicio}
                        onChange={date => {
                           handleChangeFiltros(date, 'fechaInicio');
                        }}
                        inputVariant="outlined"
                        format="dd/MM/yy"
                        fullWidth
                        margin="dense"
                        autoOk
                     />
                  </Grid>
                  <Grid item xs={3}>
                     <DatePicker
                        name="fechaFinal"
                        label="Fecha Final"
                        value={filtros.fechaFin}
                        onChange={date => {
                           handleChangeFiltros(date, 'fechaFin');
                        }}
                        inputVariant="outlined"
                        format="dd/MM/yy"
                        fullWidth
                        margin="dense"
                        autoOk
                     />
                  </Grid>
                  <Grid item xs={3} style={{display: 'flex', alignItems: 'center'}}>
                     <Button
                        size="small"
                        color="primary"
                        variant="outlined"
                        endIcon={<SearchIcon />}
                        onClick={handleGetData}
                     >
                        Consultar
                     </Button>
                  </Grid>
               </Grid>
               <MUIDataTable
                  data={dataTable}
                  columns={columns}
                  options={options}
                  className={classes.tabla}
               />
            </CardContent>
         </Card>
      </Grid>
   );
}

function mapStateToProps(state) {
   return {
      usuario: state.auth.usuario
   };
}

function mapDispatchToProps(dispatch) {
   return {
      openWaitModal: loading => dispatch(loadingModal(loading)),
      openMsgModal: msg => dispatch(openMsg(msg))
   };
}

export default connect(mapStateToProps, mapDispatchToProps)(ServiciosPostventa);
